<script setup lang="ts">
const userStore = useUserStore()
const modalStore = useModalStore()
</script>

<template>
  <div class="py-4">
    <div class="relative pt-16 pb-16 overflow-hidden bg-white rounded-md shadow">
      <div class="relative">
        <div class="lg:mx-auto lg:max-w-8xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
          <div class="max-w-xl px-4 mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
            <div>
              <div>
                <span class="flex items-center justify-center w-12 h-12 rounded-md bg-tomate-400">
                  <UIcon name="i-mdi-calendar-month" class="w-6 h-6 text-white" aria-hidden="true" />
                </span>
              </div>
              <div class="mt-6">
                <h2 class="text-3xl font-extrabold tracking-tight text-poivre-800 font-title">
                  Une cuisine organisée
                </h2>
                <p class="mt-4 text-lg text-poivre-500">
                  Notre <span class="font-medium">Planificateur</span> est un calendrier simple qui vous permet de garder une trace de ce que vous cuisinez. Prévoyez d'avance vos repas pour éviter les oublis et multiples voyages au supermarché.
                </p>
                <div class="mt-4 text-lg text-poivre-500">
                  <p>Ajoutez des recettes depuis Glouton ou importez en de n'importe quel site Web. Pour une recette provenant d'un livre ou de votre tête, ajoutez des notes comme sur un babillard.</p>
                </div>
              </div>
            </div>
            <div class="pt-6 mt-8 border-t border-poivre-200">
              <blockquote>
                <div>
                  <p class="text-base text-poivre-500">
                    «On est 5 à la maison, ça devient vite le bordel dans la cuisine et à l'épicerie. Ça me permet d'avoir une meilleure visibilité pour les repas et les lunchs, et de m'assurer de pas toujours cuisiner la même chose.»
                  </p>
                </div>
                <footer class="mt-3">
                  <div class="flex items-center space-x-3">
                    <div class="flex-shrink-0">
                      <img class="w-6 h-6 rounded-full" src="/images/testimonials/susie.jpg" alt="">
                    </div>
                    <div class="text-base">
                      <span class="font-medium text-poivre-700">Susie A.</span><span class="text-poivre-500">, Montréal</span>
                    </div>
                  </div>
                </footer>
              </blockquote>
            </div>
          </div>
          <div class="mt-12 sm:mt-16 lg:mt-0">
            <div class="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
              <img
                class="w-full lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none"
                src="https://glouton.b-cdn.net/site/images/mockups/welcome2.jpg"
                alt="Planificateur de menus"
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-10 bg-white rounded-md shadow">
      <div class="px-4 py-12 mx-auto text-center max-w-8xl sm:px-6 lg:py-16 lg:px-8">
        <h2 class="mb-2 text-3xl font-extrabold tracking-tight text-poivre-800 sm:text-4xl font-title">
          <span class="block">Prêt à cuisiner?</span>
        </h2>
        <p class="text-sm text-poivre-600">
          Un abonnement <ULink :to="$localePath({ name: 'ExtraPage' })" class="underline">
            <span class="font-semibold">Extra</span>
          </ULink> est requis pour utiliser notre planificateur de menus.
        </p>
        <div v-if="!userStore.user" class="flex justify-center mt-5 space-x-3">
          <UButton type="button" icon="i-mdi-login-variant" label="Connexion" @click="modalStore.openLoginModal" />
          <UButton as="a" :to="$localePath({ name: 'RegisterPage' })" label="Créer un compte" />
        </div>
      </div>
    </div>
  </div>
</template>
